import React from "react";
import { X, RotateCcw, Filter, Truck } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { Slider } from "../ui/slider";

export default function CategoryMobileFilters({
    filtersOpen, setFiltersOpen,
    catBrands, selectedBrands, toggleBrand,
    paramOptions, selectedParams, toggleParam,
    inStockOnly, setInStockOnly,
    onSaleOnly, setOnSaleOnly,
    priceRange, setPriceRange,
    hasFilters, clearFilters
}) {
    if (!filtersOpen) return null;

    return (
        <div className="fixed inset-0 z-50 lg:hidden">
            <div className="absolute inset-0 bg-black/50" onClick={() => setFiltersOpen(false)} />
            <div className="absolute right-0 top-0 bottom-0 w-80 bg-white shadow-2xl overflow-y-auto rounded-l-2xl">
                <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 sticky top-0 bg-white z-10">
                    <h3 className="font-bold text-gray-900">Filtry</h3>
                    <button onClick={() => setFiltersOpen(false)} className="p-2 rounded-full hover:bg-gray-100"><X size={18} /></button>
                </div>
                <div className="p-4 space-y-4">
                    {catBrands.length > 0 && (
                        <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
                            <div className="bg-gray-50 px-4 py-2.5 border-b text-xs font-bold text-gray-600 uppercase tracking-wide">Výrobce</div>
                            <div className="p-3 space-y-1.5 max-h-52 overflow-y-auto">
                                {catBrands.map(b => (
                                    <label key={b} className="flex items-center gap-3 cursor-pointer py-1 text-sm">
                                        <Checkbox checked={selectedBrands.includes(b)} onCheckedChange={() => toggleBrand(b)} />
                                        <span>{b}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}
                    {paramOptions.length > 0 && (
                        <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
                            <div className="bg-gray-50 px-4 py-2.5 border-b text-xs font-bold text-gray-600 uppercase tracking-wide">Parametry</div>
                            <div className="p-3 space-y-3">
                                {paramOptions.slice(0, 6).map(po => (
                                    <div key={po.key}>
                                        <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wide mb-1">{po.key}</p>
                                        <div className="flex flex-wrap gap-1">
                                            {po.values.slice(0, 6).map(val => (
                                                <button key={val} onClick={() => toggleParam(po.key, val)}
                                                    className={`text-[11px] px-2 py-0.5 rounded-full ${
                                                        selectedParams[po.key] === val
                                                            ? "bg-green-600 text-white"
                                                            : "bg-gray-100 text-gray-600"
                                                    }`}>{val}</button>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
                        <div className="bg-gray-50 px-4 py-2.5 border-b text-xs font-bold text-gray-600 uppercase tracking-wide">Dostupnost</div>
                        <div className="p-3 space-y-2">
                            <label className="flex items-center gap-3 cursor-pointer text-sm"><Checkbox checked={inStockOnly} onCheckedChange={v => setInStockOnly(v)} />Pouze skladem</label>
                            <label className="flex items-center gap-3 cursor-pointer text-sm text-red-600 font-medium"><Checkbox checked={onSaleOnly} onCheckedChange={v => setOnSaleOnly(v)} />Ve slevě</label>
                        </div>
                    </div>
                    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
                        <div className="bg-gray-50 px-4 py-2.5 border-b text-xs font-bold text-gray-600 uppercase tracking-wide">Cena (Kč)</div>
                        <div className="p-4">
                            <Slider min={0} max={200000} step={500} value={priceRange} onValueChange={setPriceRange} />
                            <div className="flex justify-between text-xs text-gray-500 mt-2">
                                <span>{priceRange[0].toLocaleString("cs-CZ")} Kč</span>
                                <span>{priceRange[1] >= 200000 ? "max" : `${priceRange[1].toLocaleString("cs-CZ")} Kč`}</span>
                            </div>
                        </div>
                    </div>
                    {hasFilters && (
                        <button onClick={() => { clearFilters(); setFiltersOpen(false); }}
                            className="w-full py-2.5 text-sm text-red-500 border border-red-200 rounded-full hover:bg-red-50 flex items-center justify-center gap-2">
                            <RotateCcw size={13} /> Vymazat všechny filtry
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
